import api from './api';

/**
 * Buyer-facing property listings. `list`, `get` and `similar` work signed out —
 * a token, when present, only adds the `saved` flag and a finer pin. The save
 * and enquiry calls need a signed-in user.
 */
const publicListingsService = {
  list: (params) => api.get('/public/listings', { params }).then((r) => r.data),
  get: (id) => api.get(`/public/listings/${id}`).then((r) => r.data),
  similar: (id) => api.get(`/public/listings/${id}/similar`).then((r) => r.data),

  /** The signed-in buyer's saved homes, newest save first. */
  saved: () => api.get('/listings/saved').then((r) => r.data),
  save: (id) => api.put(`/listings/${id}/save`).then((r) => r.data),
  unsave: (id) => api.delete(`/listings/${id}/save`).then((r) => r.data),

  /** Saved searches: the browse filters with a name. */
  savedSearches: () => api.get('/listings/saved-searches').then((r) => r.data),
  saveSearch: (payload) => api.post('/listings/saved-searches', payload).then((r) => r.data),
  deleteSavedSearch: (id) => api.delete(`/listings/saved-searches/${id}`).then((r) => r.data),
  pauseSavedSearch: (id, paused) => api.patch(`/listings/saved-searches/${id}`, { paused }).then((r) => r.data),

  /**
   * Opens (or reuses) the chat thread with the realtor. Accepts a bare message
   * string for the plain enquiry the detail page has always sent, or an object
   * when the request carries a kind and preferred dates (a viewing request).
   */
  enquire: (id, payload) => {
    const body = typeof payload === 'string' || payload == null
      ? (payload ? { message: payload } : {})
      : {
        ...(payload.message ? { message: payload.message } : {}),
        ...(payload.kind ? { kind: payload.kind } : {}),
        ...(payload.preferredDates ? { preferredDates: payload.preferredDates } : {}),
      };
    return api.post(`/listings/${id}/enquiries`, body).then((r) => r.data);
  },
};

export default publicListingsService;
